import Vue from "vue";
import Vuex from "vuex";

import actions, {
    AddTracking, AppActionTypes, GetOrder, PutAddress, restClient, SetCheckout, SetPromotion, SetSettings,
    SetValidationRules
} from "./actions";
import getters, { AppGetterTypes, GetPropertyValidationRules } from "./getters";
import IAppState from "./IAppState";
import mutations, { AppMutationTypes } from "./mutations";

// https://vuex.vuejs.org/
Vue.use(Vuex);

const initialState: IAppState = {
    version: process.env.VUE_APP_VERSION || "",
    validationRules: {},
    paymentMethods: [],
    genericOrderFailedMessage: "",
    pageTitle: ""
};

const store = new Vuex.Store({
    state: initialState,

    // https://vuex.vuejs.org/guide/getters.html
    getters: getters,

    // https://vuex.vuejs.org/guide/mutations.html
    mutations: mutations,

    // https://vuex.vuejs.org/guide/actions.html
    actions: actions,

    // https://vuex.vuejs.org/guide/modules.html
    modules: {}
});

export default store;

export {
    AppGetterTypes,
    AppMutationTypes,
    AppActionTypes,
    GetPropertyValidationRules,
    SetPromotion,
    SetValidationRules,
    SetCheckout,
    SetSettings,
    GetOrder,
    AddTracking,
    PutAddress,
    restClient
};
